export const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Über Denis Bitter – Lehre. Code. Haltung.",
  "url": "https://www.denisbitter.de/about",
  "description": "Wer ist Denis Bitter? Lernarchitekt. Entwickler. Dozent. Mit Haltung, Tiefe und Fokus auf echte Wirkung.",
  "publisher": {
    "@type": "Person",
    "name": "Denis Bitter",
    "url": "https://www.denisbitter.de/about",
    "sameAs": [
      "https://www.instagram.com/denisbitter",
      "https://www.linkedin.com/in/denisbitter",
      "https://www.facebook.com/denisbitter",
      "https://www.youtube.com/@denisbiutterfullstack",
      "https://www.tiktok.com/@theoriginalbitter",
      "https://www.x.com/theoriginalbitter"
    ]
  }
};
